<template>
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12">
        <h1>
          <button class="btn btn-sm btn-dark back" type="button" v-on:click="showAreaList">
            <i class="fa fa-caret-left"></i>
            Tillbaka
          </button>
          <span>{{ area.title }} {{ selectedFilter !== filters[0] ? '(Filtrerad)' : '' }}</span>
          <button class="btn btn-sm btn-dark filter" type="button" v-on:click="showFilterModal">
            Filtrera
          </button>
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <ul class="button-list">
          <li
            class="button-list-item has-season"
            v-for="(spot, index) in filteredSpots"
            :key="spot.id"
            :class="{ 'has-note': spot.notes.length > 0 }"
            v-on:click="showSpot(spot, index)"
          >
            <span class="button-list-item-season" :class="'season-' + getSeason(spot)"></span>
            <span class="button-list-item-caption">{{ spot.title }}</span>
            <span class="button-list-item-comment"
              >(TS: {{ daysSince(spot, 'latest_visit') }},
              <span :class="{ overdue: isOverdue(spot) }">V: {{ daysSince(spot, 'latest_watered') }}</span
              >)</span
            >
            <span class="button-list-item-icon">
              <i class="fa fa-chevron-right"></i>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="overlay" v-if="filterModal.visible" v-on:click="closeFilterModal">
      <div class="dialog">
        <div class="dialog-header">
          <h2>Filtrera</h2>
        </div>
        <div class="dialog-body">
          <label for="filter">Filter:</label>
          <select id="filter" class="form-control" v-model="filterModal.selectedFilter">
            <option v-for="filter in filters" :value="filter">{{ filter.caption }}</option>
          </select>
          <button class="btn btn-light form-control" type="button" v-on:click="saveFilter">Spara</button>
          <button class="btn btn-light form-control cancel" type="button" v-on:click="closeFilterModal">Avbryt</button>
        </div>
      </div>
    </div>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
import { settings } from '@/resources';
import router from '@/router';
import { communicationUtil } from '@/utilities';
import moment from 'moment';

import { Loader } from '@/components';

export default {
  name: 'Area',
  mixins: [communicationUtil],
  data: function() {
    let overdueCheck = this.isOverdue;
    let areaType = this.$store.getters.selectedAreaType;
    let defaultFilters = [
      {
        caption: 'Inget filter',
        execute: function(spots) {
          return spots;
        }
      },
      {
        caption: 'Senast besökt över tiden',
        execute: function(spots) {
          return spots.filter(spot => overdueCheck(spot));
        }
      }
    ];

    return {
      loading: false,
      area: {
        spots: []
      },
      type: areaType,
      filterModal: {
        defaultFilters: defaultFilters,
        visible: false,
        selectedFilter: defaultFilters[0]
      },
      selectedFilter: defaultFilters[0],
      seasons: []
    };
  },
  mounted: function() {
    let areaId = this.$store.getters.selectedArea;

    this.loading = true;
    this.get(`${settings.backend}/season/list`).then(response => {
      this.seasons = response.data;
    });
    if (areaId > 0) {
      this.get(`${settings.backend}/area/${areaId}/details?type=${this.type}`).then(response => {
        this.area = response.data;
        this.plantTypes = this.getUniquePlantTypes(response.data.spots.map(spot => spot.plant_type));
        this.loading = false;
      });
      return;
    }

    this.get(`${settings.backend}/spots/all`).then(response => {
      this.area = {
        spots: response.data,
        name: 'Alla'
      };
      this.plantTypes = this.getUniquePlantTypes(response.data.map(spot => spot.plant_type));
      this.loading = false;
    });
  },
  components: {
    loader: Loader
  },
  computed: {
    filters: function() {
      return [
        ...this.filterModal.defaultFilters,
        ...this.plantTypes.map(plantType => {
          return {
            caption: `Planteringstyp: ${plantType.title}`,
            execute: function(spots) {
              return spots.filter(spot => spot.plant_type.id === plantType.id);
            }
          };
        }),
        ...this.seasons.map(season => {
          return {
            caption: `Säsong ${season.title}`,
            execute: function(spots) {
              return spots.filter(spot => spot.season.id === season.id);
            }
          };
        })
      ];
    },
    filteredSpots: function() {
      return (this.selectedFilter.execute ? this.selectedFilter.execute(this.area.spots) : this.area.spots).sort(
        (a, b) => {
          if (this.type === 'virtual') {
            return a.pivot.sort_id - b.pivot.sort_id;
          }
          return a.sort_id - b.sort_id;
        }
      );
    }
  },
  methods: {
    handleException: function(exception) {
      console.log('Exception', exception);
    },
    getUniquePlantTypes: function(plantTypes) {
      let plantTypeMap = {};

      plantTypes.forEach(function(plantType) {
        if (!plantTypeMap[plantType.id]) {
          plantTypeMap[plantType.id] = plantType;
        }
      });

      return Object.values(plantTypeMap);
    },
    daysSince: function(spot, type) {
      return spot[type] ? moment().diff(moment(spot[type].time_of_visit), 'days') : 'Aldrig';
    },
    isOverdue: function(spot) {
      if (!spot.latest_watered) {
        return true;
      }

      return this.daysSince(spot, 'latest_watered') > spot.plant_type.visit_frequency;
    },
    closeFilterModal: function(e) {
      if (e.target.className === 'overlay' || e.target.className === 'btn btn-light form-control cancel') {
        this.filterModal.visible = false;
      }
    },
    getSeason: function(spot) {
      return spot.season ? spot.season.id : 1;
    },
    saveFilter: function() {
      this.selectedFilter = this.filterModal.selectedFilter;
      this.filterModal.visible = false;
    },
    showAreaList: function() {
      router.push('/areas');
    },
    showFilterModal: function() {
      this.filterModal.selectedFilter = this.selectedFilter;
      this.filterModal.visible = true;
    },
    showSpot: function(spot) {
      this.$store.commit('spot', spot.id);
      this.$store.commit(
        'availableSpots',
        this.filteredSpots.map(spot => spot.id)
      );
      router.push('/spot');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Area.vue